import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    /* ===== Compatibilidade (tokens legados — não remover) ===== */
    --primary-color: #4D148C;
    --secondary-color: #FF6600;
    --primary-rgb: 77, 20, 140;
    --secondary-rgb: 255, 102, 0;
    --white: #FFFFFF;
    --black: #000000;
    --gray-50: #F9FAFB;
    --gray-100: #F3F4F6;
    --gray-200: #E5E7EB;
    --gray-300: #D1D5DB;
    --gray-400: #9CA3AF;
    --gray-500: #6B7280;
    --gray-600: #4B5563;
    --gray-700: #374151;
    --gray-800: #1F2937;
    --gray-900: #111827;
    --error: #EF4444;
    --success: #10B981;
    --warning: #F59E0B;

    /* ===== Redesign — Marca ===== */
    --brand-700: #460C79;
    --brand-600: #4D148C;
    --brand-500: #6B21A8;
    --brand-400: #8B3FC4;
    --brand-100: #F3EAFB;
    --brand-50: #FAF6FE;
    --brand-gradient: linear-gradient(135deg, #4D148C 0%, #6B21A8 100%);
    --brand-gradient-hover: linear-gradient(135deg, #5B1A9B 0%, #7C2DB8 100%);

    /* ===== Acento ===== */
    --accent-600: #FF6600;
    --accent-50: #FFF3EA;

    /* ===== Neutros ===== */
    --ink-900: #111827;
    --ink-700: #374151;
    --ink-500: #6B7280;
    --ink-300: #D1D5DB;
    --line-200: #E5E7EB;
    --surface: #FFFFFF;
    --bg: #F6F5F9;

    /* ===== Semânticos ===== */
    --success-600: #10B981;
    --success-50: #ECFDF5;
    --error-600: #EF4444;
    --error-50: #FEF2F2;
    --warning-600: #F59E0B;

    /* ===== Tipografia (composta para uso via font:) ===== */
    --fs-display: 700 28px/1.15 'Montserrat', sans-serif;
    --fs-h2: 600 20px/1.25 'Montserrat', sans-serif;
    --fs-body: 400 16px/1.5 'Montserrat', sans-serif;
    --fs-label: 600 14px/1.4 'Montserrat', sans-serif;
    --fs-helper: 500 13px/1.4 'Montserrat', sans-serif;
    --fs-eyebrow: 700 12px/1.3 'Montserrat', sans-serif;

    /* ===== Espaçamento (base 8) ===== */
    --s-1: 4px;
    --s-2: 8px;
    --s-3: 12px;
    --s-4: 16px;
    --s-5: 20px;
    --s-6: 24px;
    --s-8: 32px;
    --s-10: 40px;
    --s-12: 48px;

    /* ===== Radius ===== */
    --r-sm: 8px;
    --r-md: 12px;
    --r-lg: 16px;
    --r-xl: 20px;
    --r-full: 999px;

    /* ===== Sombras ===== */
    --shadow-xs: 0 1px 2px rgba(17, 24, 39, .06);
    --shadow-sm: 0 2px 8px rgba(70, 12, 121, .06);
    --shadow-md: 0 8px 24px rgba(77, 20, 140, .12);
    --shadow-lg: 0 16px 40px rgba(77, 20, 140, .16);
    --shadow-cta: 0 8px 20px rgba(77, 20, 140, .32);
    --focus-ring: 0 0 0 3px rgba(77, 20, 140, .18);
    --focus-ring-error: 0 0 0 3px rgba(239, 68, 68, .15);

    /* ===== Motion ===== */
    --dur-fast: 120ms;
    --dur-base: 200ms;
    --dur-slow: 320ms;
    --ease: cubic-bezier(0.22, 1, 0.36, 1);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
  }

  body {
    font-family: 'Montserrat', sans-serif;
    background: var(--bg);
    min-height: 100vh;
    color: var(--ink-900);
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    line-height: 1.2;
  }

  p, span, div, input, textarea, select, button {
    font-family: 'Montserrat', sans-serif;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
  }

  input, textarea, select {
    font-family: 'Montserrat', sans-serif;
    border: none;
    outline: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: .001ms !important;
      transition-duration: .001ms !important;
    }
  }
`;
